import Vue from 'vue'

export default (campaignName) => {
  return `${campaignName} ${Vue.moment(Date.now()).format('YYYY-M-D hh:mm:ss')}`
}
